import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Form, Col } from 'react-bootstrap';
import { Checkbox } from 'pretty-checkbox-react';
import { sortBy, orderBy } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';

import { ApiServiceServerless } from '../../../xhr_libs';
import EnergyTracerTable from '../../tables';


export default function PlugMeterListModal(props) {
  const {
    show,
    onHide,
    showToast,
    meterGroup,
    setMeterGroup,
    allCredentials,
  } = props;


  const [localMeterList, setLocalMeterList] = useState([]);

  const [isLoading, setIsLoading] = useState(false)

  const [credentialId, setCredentialId] = useState('');
  const [plugMeters, setPlugMeters] = useState([]);
  const [plugMeterIds, setPlugMeterIds] = useState([]);

  const [sortedPlugMeters, setSortedPlugMeters] = useState([]);
  const [sortOptions, setSortOptions] = useState([]);

  useEffect(() => {
    let plug_meters = plugMeters.map((meter) => {
      let temp_meter = { ...meter };
      temp_meter.accountNumber = temp_meter.accounts[0].accountNumber
      temp_meter.meterNumber = temp_meter.meterNumber ? temp_meter.meterNumber : temp_meter.accountNumber
      temp_meter.ratePlan = temp_meter.currentTariff ? temp_meter["currentTariff"]["tariffName"] : ''
      temp_meter.fullAddress = temp_meter.serviceAddress ? temp_meter["serviceAddress"]["fullAddress"] : ''
      return temp_meter
    })


    let orderlist = [];
    let orderDirs = [];
    sortOptions.forEach((option) => {
      if (option.type === 'filter' && option.value !== '') {
        plug_meters = plug_meters.filter((meter) => meter[option.key] && meter[option.key].toLowerCase().includes(option.value.toString().toLowerCase()))
      }
      if (option.type === 'sort') {
        orderlist.push(option.key)
        orderDirs.push(option.value)
      }
    })

    if (orderlist.length > 0) {
      plug_meters = orderBy(plug_meters, orderlist, orderDirs);
    }

    setSortedPlugMeters(plug_meters)
  }, [plugMeters, sortOptions])



  useEffect(() => {
    setLocalMeterList(meterGroup.meter_list)
  }, [meterGroup]);


  const updateMeterGroup = () => {
    setMeterGroup((prev) => {
      prev.meter_list = localMeterList
      return { ...prev }
    })
    onHide()
  }


  const getPlugMeterGroups = (existingMeterIds) => {
    setIsLoading(true)
    ApiServiceServerless.post(
      `/plug/credential_meters`,
      {
        credentialId: credentialId,
      },
    )
      .then(({ data }) => {
        let new_meters = []
        let new_meter_ids = []

        data.forEach((meter) => {
          if (!existingMeterIds.includes(meter.id)) {
            new_meters.push(meter)
            new_meter_ids.push(meter.id)
          }
        })
        setPlugMeters((prev) => prev.concat(new_meters))
        setPlugMeterIds((prev) => prev.concat(new_meter_ids))

        setIsLoading(false);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        setIsLoading(false);
        throw error;
      });
  }

  const updateMeterList = (meter_id) => {
    setLocalMeterList((prev) => {
      let list = [...prev]
      if (list.includes(meter_id)) { list = list.filter((meter) => meter !== meter_id) }
      else {
        list.push(meter_id)
      }
      return list
    })
  }


  const handleAddSortOption = (sortOptions, type) => {
    let option = {};
    let id = sortOptions.length;
    sortOptions.forEach((opt) => {
      if (opt.id >= id) {
        id = opt.id + 1
      }
    })
    option.type = type;
    option.id = id;
    option.key = FILTER_KEY_OPTIONS[0].key
    if (type === 'filter') {
      option.value = ''
    }
    if (type === 'sort') {
      option.value = 'asc'
    }
    setSortOptions((prev) => [...prev, option])
  }



  const tableColumns = [
    {
      dataField: 'id',
      text: 'Selected',
      formatExtraData: {
        localMeterList: localMeterList,
      },
      formatter: (cell, row, rowIndex, formatExtraData) => <Checkbox
        style={{
          fontSize: '1.25em',
          marginBottom: '0.5em',
        }}
        color={'primary-o'}
        onChange={() => {
          updateMeterList(cell);
        }}
        checked={formatExtraData.localMeterList.includes(cell)}
        key={cell}
      >
        {''}
      </Checkbox>
    },
    {
      dataField: 'meterNumber',
      text: 'Meter Number',
    },
    {
      dataField: 'accountNumber',
      text: 'Account Number',
      formatter: (cell, row) =>
        row.accounts[0].accountNumber
    },
    {
      dataField: 'serviceType',
      text: 'Service Type',
    },
    {
      dataField: 'currentTariff',
      text: 'Rate Plan',
      formatter: (cell, row) =>
        row.currentTariff ? row["currentTariff"]["tariffName"] : ''
    },
    {
      dataField: 'latestStatementDate',
      text: 'Last Statement Date',
    },
    {
      dataField: 'serviceAddress',
      text: 'Service Address',
      style: { 'maxWidth': '200px' },
      formatter: (cell, row) =>
        row.serviceAddress ? row["serviceAddress"]["fullAddress"] : ''
    },

  ]


  return (
    <Modal show={show} onHide={onHide} size='xl'>
      <Modal.Header closeButton>Create Meter List</Modal.Header>
      <Modal.Body>
        <div>
          <h4>
            Download Meters
          </h4>
          <Row>
            <Col md={10}>
              <Row>
                <div style={{ marginLeft: '30px' }}>
                  Credential:
                  <Form style={{ width: '400px', display: 'inline-block' }}>
                    <Form.Control
                      as='select'
                      onChange={(e) => setCredentialId(e.target.value)}
                      value={credentialId}
                    >
                      <option key={''} value={''} hidden>
                        {''}
                      </option>
                      {sortBy(allCredentials, ['utilityProvider']).map((cred) => (
                        <option key={cred['id']} value={cred['id']}>
                          {cred['utilityProvider'] + " - " + cred['username']}
                        </option>
                      ))}
                    </Form.Control>
                  </Form>
                  <Button
                    disabled={!credentialId || isLoading} style={{ 'marginLeft': '25px', 'marginRight': '10px' }}
                    onClick={() => getPlugMeterGroups(plugMeterIds)}> {isLoading ? 'Retrieving' : 'Retrieve'}</Button>
                  <Button disabled={isLoading} variant='outline-danger' onClick={() => { setPlugMeters([]); setPlugMeterIds([]) }}> Clear All Meters</Button>
                </div>
              </Row>
            </Col>
          </Row>
        </div>
        <br></br>
        <div>
          <h4>
            Meter Selection
          </h4>
          <div style={{ marginBottom: '15px' }}>
            <Button style={{ marginRight: '10px' }} onClick={() => setLocalMeterList(sortedPlugMeters.map((meter) => meter.id))}>Select All Meters</Button>
            <Button onClick={(() => setLocalMeterList([]))}>Deselect All Meters</Button>
            <Button
              style={{ marginLeft: '10px', marginRight: '10px' }}
              onClick={(() => handleAddSortOption(sortOptions, 'filter'))}
            >Add Filter</Button>
            <Button onClick={(() => handleAddSortOption(sortOptions, 'sort'))}>Add Sort</Button>
          </div>

          <div>
            {sortOptions.map((option) => <PlugMeterSortOption key={option.id} sortOption={option} setSortOptions={setSortOptions} />)}
          </div>
          <div style={{ maxHeight: '400px', overflowY: 'scroll', width: '100%', marginTop: '10px', paddingLeft: "15px" }}>
            <EnergyTracerTable data={sortedPlugMeters} columns={tableColumns} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='float-right ml-3'
          type='button'
          variant='outline-danger'
          onClick={() => onHide()}
        >
          Cancel
        </Button>
        <Button
          className='float-right ml-3'
          onClick={() => updateMeterGroup()}
          disabled={localMeterList.length === 0 || isLoading}
          title={
            localMeterList.length === 0 ? 'One selection required.' : null
          }
        >
          {' '}
          Confirm
        </Button>

      </Modal.Footer>
    </Modal>
  );
}

const FILTER_KEY_OPTIONS = [{ name: 'Meter Number', key: 'meterNumber' },
{ name: 'Account Number', key: 'accountNumber' },
{ name: 'Service Type', key: 'serviceType' },
{ name: 'Rate Plan', key: 'ratePlan' },
{ name: 'Last Statement Date', key: 'latestStatementDate' },
{ name: 'Service Address', key: 'fullAddress' }]



function PlugMeterSortOption(props) {
  const { sortOption, setSortOptions } = props;

  const handleChangeOption = (id, key, value) => {
    setSortOptions((prev) =>
      prev.map((opt) => {
        if (opt.id !== id) return opt;
        opt[key] = value
        return opt;
      })
    )
  }

  const deleteRow = (id) => {
    setSortOptions((prev) =>
      prev.filter((opt) => opt.id !== id)
    )
  }

  return <>
    <div style={{ width: '80%', paddingLeft: '50px', marginBottom: '5px' }}>
      <Form as={Row}>
        <Form.Group as={Col} style={{ marginBottom: 0 }}>
          <Form.Label style={{ margin: '0' }}>
            {sortOption.type === 'filter' ? "Filter" : "Sort"} Key
          </Form.Label>
          <Form.Control
            style={{ float: 'right' }}
            as='select'
            size='sm'
            value={sortOption.key}
            onChange={(e) => handleChangeOption(sortOption.id, 'key', e.target.value)}
          >
            {FILTER_KEY_OPTIONS.map((option) => (
              <option
                key={`option-opt-${option.key}`}
                value={option.key}
              >
                {option.name}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Form.Group as={Col} style={{ marginBottom: 0 }}>
          <Form.Label style={{ margin: '0' }}>
            {sortOption.type === 'filter' ? "Filter" : "Sort"} Value
          </Form.Label>
          {sortOption.type === 'filter' &&
            <Form.Control
              required
              style={{ height: '30px' }}
              value={sortOption.value}
              onChange={(e) => handleChangeOption(sortOption.id, 'value', e.target.value)}
            />}
          {sortOption.type === 'sort' &&
            <Form.Control
              style={{ float: 'right' }}
              as='select'
              size='sm'
              value={sortOption.value}
              onChange={(e) => handleChangeOption(sortOption.id, 'value', e.target.value)}
            >
              <option
                key={`asc`}
                value={'asc'}
              >
                Ascending
              </option>
              <option
                key={`desc`}
                value={'desc'}
              >
                Descending
              </option>
            </Form.Control>}
        </Form.Group>
        <Col style={{ marginBottom: 0 }}>
          <FontAwesomeIcon
            style={{
              position: 'absolute',
              top: '33px',
              fontSize: '18px',
              lineHeight: 'inherit',
              color: 'red',
              cursor: 'pointer',
            }}
            icon={faTimesCircle}
            onClick={() => deleteRow(sortOption.id)}
          />
        </Col>
      </Form>
    </div>
  </>
}